import { inject } from 'vue';

/**
 * Возвращает ссылку на DOM элемент - точку монтирования модального окна.
 *
 * Ожидает наличия `'shadowRoot'` в provide.
 * Если showRoot недоступен, возвращается `undefined`.
 *
 * @param querySelector строка для поиска элемента в ShadowDOM
 */
export const useModalTarget = (querySelector = '.modal-target') => {
  const shadowRoot = inject<ShadowRoot | null>('shadowRoot', null);

  if (!shadowRoot) {
    return undefined;
  }

  const modalTarget = shadowRoot.querySelector(querySelector);

  return (modalTarget as HTMLElement) ?? undefined;
};
